

































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { userType } from '@/app/model/store/domain/const'
import Local from '@/app/module/local'

@Component
export default class AccountList extends Vue {
  private userType: string = ''
  private displayRemarksData: string = ''
  private constantValue: any = []

  @Prop() private data!: any

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
  }

  private displayUserType (type: number) {
    const userTypeData = this.constantValue.user_types.filter((data: any) => data.user_type_id === type)
    if (userTypeData.length === 0) {
      return '-'
    } else {
      return userTypeData[0].user_type_name
    }
  }
}

